module.exports = __webpack_public_path__ + "static/media/swords.7b879c6b.svg";